import { ESTOQUE } from '../constants/apiRoutes';
import api from './api';


export default {
	createEstoque(values) {
		return api.post(ESTOQUE.FIND_ALL, values);
	},

	createMovimentacao(values) {
		return api.post(ESTOQUE.FIND_MOVIMENTACAO, values);
	},

	findByDacaId(id) {
		return api.get(ESTOQUE.FIND_ID.replace('{id}', id));
	},

	findOrigemByDacaId(dacaId, estoqueOrigemId) {
		if (estoqueOrigemId === '') {
			estoqueOrigemId = 0;
		}
		return api.get(ESTOQUE.FIND_ORIGEM_DACA.replace('{dacaId}', dacaId).replace('{estoqueOrigemId}', estoqueOrigemId));
	},

	saveSaida(saida) {
		return api.post(ESTOQUE.SAIDA, saida);
	},

	findAllOcorrencias() {
		return api.get(ESTOQUE.FIND_ALL_ATIVAS);
	},

	findEstoquesByDacaId(id) {
		return api.get(ESTOQUE.FIND_ID.replace('{id}', id));
	},

	findDestinoEmprestimoByIdDaca(id) {
		return api.get(ESTOQUE.FIND_DESTINO_EMPRESTIMO.replace('{id}', id));
	},

	findDestinoEmprestimoByIdDacaForEdit(id, idEmprestimo) {
		return api.get(ESTOQUE.FIND_DESTINO_EMPRESTIMO.replace('{id}', id).replace('{idEmprestimo}', idEmprestimo));
	},
};
